import AutoDeliveries from './components/autoDeliveries';

export default AutoDeliveries;